import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class RenameService {

  readonly showRenameModal = signal<{
    assessment_id:number, 
    company_id:string, 
    risk_source_type_id:number, risk_source_id: number,
    risk_source_name:string
  }|undefined>(undefined);

  private _renamedTo = new Subject<string|undefined>();
  readonly renamedTo$ = this._renamedTo.asObservable();

  renamedTo(nuName: string|undefined) {
    this._renamedTo.next(nuName);
  }

}

